import Image from "next/image"
import { ComponentProps } from "react"

import { appBaseName } from "@/config/consts"

type ImageProps = ComponentProps<typeof Image> & {
  src: string
  alt: string
  width: number
  height: number
}

const Img = ({ alt, height, src, width, ...restOfProps }: ImageProps) => (
  <Image
    src={`${appBaseName}${src}`}
    alt={alt}
    width={width}
    height={height}
    {...restOfProps}
  />
)

export { Img }
